(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-slider-bar"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var wrapper = document.querySelector('.sorta_banner_title');
  if (!wrapper) return;
  var fillText = wrapper.querySelector('.h1-original');
  var outlineText = wrapper.querySelector('.h1-copy');

  var maxShift = 0;
  var lastClip = -1;
  var lastShift = -1;

  function measure() {
    var textWidth = fillText.scrollWidth;
    var containerWidth = wrapper.clientWidth;
    maxShift = Math.max(textWidth - containerWidth, 0);
  }

  function calcProgress() {
    var rect = wrapper.getBoundingClientRect();
    var windowHeight = window.innerHeight;
    var progress = (windowHeight - rect.top) / windowHeight;
    return Math.min(Math.max(progress, 0), 1);
  }

  function loop() {
    var progress = calcProgress();

    var shift = Math.round(progress * maxShift);
    if (shift !== lastShift) {
      var transformVal = 'translateX(-' + shift + 'px)';
      fillText.style.transform = transformVal;
      outlineText.style.transform = transformVal;
      lastShift = shift;
    }

    var rightClip = Math.round((1 - progress) * 1000) / 10;
    if (rightClip !== lastClip) {
      fillText.style.clipPath = 'inset(0 ' + rightClip + '% 0 0)';
      lastClip = rightClip;
    }

    requestAnimationFrame(loop);
  }

  measure();
  window.addEventListener('resize', measure);
  requestAnimationFrame(loop);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
